
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","stroke":"#6C7684","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M13.456 26.862a1.2 1.2 0 01-1.75-1.26l.867-5.026-3.677-3.56a1.2 1.2 0 01.668-2.044l5.084-.733 2.271-4.576a1.21 1.21 0 012.165 0l2.271 4.576 5.084.733a1.2 1.2 0 01.669 2.044l-3.68 3.558.868 5.025a1.2 1.2 0 01-1.75 1.263L18 24.492l-4.544 2.37z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    